import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { Typography } from "@stardust-ds/react"
import { useEffect, useState, useContext } from "react"
import intl from "react-intl-universal"

import Input from "../../atoms/Input"
import RcmpModalAdd from "../../molecules/ModalAdd"
import Label from "../../atoms/Label"
import Select from "../../atoms/Select"
import styles from "./index.module.scss"
import RcmpSelectUsers from "../../molecules/SelectUsers"
import PaineisContext from "../../../contexts/Paineis"
import BoardContext from "../../../contexts/Board"
import useCheckSubmitRegister from "../../../hooks/useCheckSubmitRegister"

export default function RcmpModalAddBoard(props) {
  const {
    bIsOpen,
    buttonCancelText,
    buttonSaveText,
    fnHandleCancel,
    fnHandleCreateBoard,
    schema,
    bIsEdit,
    fnHandleUpdateBoardSubmit,
    aBoardData,
    aNorms,
  } = props

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: yupResolver(schema),
  })

  const [aDataResponsibles, fnSetDataResponsibles] = useState([])
  const [aObserversData, fnSetAObserversData] = useState([])
  const [aDataNorms, fnSetAdataNorms] = useState([])
  const [aExcludeResponsibles, fnSetAExcludeResponsibles] = useState([])
  const [aExcludeObservers, fnSetAExcludeObservers] = useState([])
  const [bLoading, fnSetBLoading] = useState(false)

  const { oCurrentPanel } = useContext(PaineisContext)
  const { oCurrentBoard } = useContext(BoardContext)

  const [fnCheckRegister, bLoadingRegister] = useCheckSubmitRegister()

  function fnResetForm() {
    reset({
      name: "",
      description: "",
      responsibles: [],
      requisites: [],
      observers: [],
    })
    fnSetDataResponsibles([])
    fnSetAObserversData([])
    fnSetAdataNorms([])
  }

  async function fnCheckBoard() {
    const oCheckRegister = {
      nBoardId: bIsEdit ? oCurrentBoard?.id : null,
      nPanelId: oCurrentPanel?.id
    }

    const cErrorMessage = bIsEdit ? intl.get("BoardsPage.update_board_error") : intl.get("BoardsPage.create_board_error")
    return await fnCheckRegister(oCheckRegister, cErrorMessage)
  }

  async function fnHandleSubmitData(data) {
    const bCanSubmit = await fnCheckBoard()
    if (!bCanSubmit) {
      fnHandleCancelAddBoard()
      return
    }

    fnSetBLoading(true)

    if (!bIsEdit) {
      await fnHandleCreateBoard(data)
    }

    if (bIsEdit) {
      await fnHandleUpdateBoardSubmit(data)
      fnHandleCancel()
    }

    fnSetBLoading(false)
    return fnResetForm()
  }

  function fnHandleCancelAddBoard() {
    if (bSubmitLoading) return

    fnHandleCancel()
    return fnResetForm()
  }

  useEffect(() => {
    if (!aBoardData) return
    const aObservers = aBoardData?.observers.map((o) => ({
      value: o?.user_nid,
      label: o?.user_cname,
    }))

    const aResponsibles = aBoardData?.responsibles.map((r) => ({
      value: r?.user_nid,
      label: r?.user_cname,
    }))

    const aNorms = aBoardData?.requisite_items?.map((n) => ({
      value: n?.req_nid,
      label: n?.req_cname,
    }))

    fnSetAObserversData(aObservers)
    fnSetAExcludeResponsibles(aObservers?.map((o) => o.value))
    fnSetAdataNorms(aNorms)

    fnSetDataResponsibles(aResponsibles)
    fnSetAExcludeObservers(aResponsibles?.map((r) => r.value))
    reset({
      ...aBoardData,
      requisites: aDataNorms,
      responsibles: aDataResponsibles,
      observers: aObserversData
    })
  }, [aBoardData])

  function fnOnSelectResponsibles(aResponsibles) {
    const aResponsiblesFormated = aResponsibles?.length > 0 ? aResponsibles.map((v) => v?.value) : []
    setValue("responsibles", aResponsiblesFormated)
    fnSetAExcludeObservers(aResponsiblesFormated)
  }

  function fnOnSelectObservers(aObservers) {
    const aObserversFormated = aObservers?.length > 0 ? aObservers.map((v) => v?.value) : []
    setValue("observers", aObserversFormated)
    fnSetAExcludeResponsibles(aObserversFormated)
  }


  if ((!aBoardData || !aDataResponsibles || !aObserversData) && bIsEdit)
    return null

  const cTitle = !bIsEdit ? intl.get("BoardsPage.new_board_modal") : intl.get("board.edit_board_name", { board: aBoardData?.name })
  const bSubmitLoading = bLoading || bLoadingRegister

  return (
    <RcmpModalAdd
      isOpen={bIsOpen}
      buttonCancelText={buttonCancelText}
      buttonSaveText={buttonSaveText}
      title={cTitle}
      fnHandleCancel={fnHandleCancelAddBoard}
      handleSubmit={handleSubmit}
      fnCreate={fnHandleSubmitData}
      oButtonSaveProps={{ isLoading: bSubmitLoading }}
      oButtonCancelProps={{ disabled: bSubmitLoading }}
    >
      <div className={styles.row}>
        <Input
          required
          isFullWidth
          label={`${intl.get("BoardsPage.board_name")} *`}
          placeholder={`${intl.get("BoardsPage.board_name")}...`}
          type="text"
          {...register("name")}
        />
        <Typography color="#FF3541" type="p3">
          {errors.name?.message}
        </Typography>
      </div>

      <div className={styles.rowDescription}>
        <Label>{intl.get("BoardsPage.board_description")} </Label>
        <textarea
          className={styles.description}
          placeholder={intl.get("BoardsPage.board_description_placeholder")}
          type="textarea"
          {...register("description")}
        />
        <Typography color="#FF3541" type="p3">
          {errors.description?.message}
        </Typography>
      </div>
      <div className={styles.row}>
        <Select
          multiSelect
          label={`${intl.get("BoardsPage.linked_norms")} `}
          placeholder={intl.get("select_to_add")}
          defaultValue={bIsEdit && aDataNorms}
          options={aNorms}
          isFullWidth
          searchable
          value=""
          onSelect={(e) =>
            setValue(
              "requisites",
              e?.map((v) => v.value)
            )
          }
        />
        <Typography color="#FF3541" type="p3">
          {errors.requisites?.message}
        </Typography>
      </div>
      <div className={styles.row}>
        <RcmpSelectUsers
          required
          multiSelect
          defaultValue={bIsEdit && aDataResponsibles}
          label={`${intl.get("BoardsPage.responsibles")} *`}
          isFullWidth
          searchable
          onSelect={fnOnSelectResponsibles}
          aExcludeOptions={aExcludeResponsibles}
        />
        <Typography color="#FF3541" type="p3">
          {errors.responsibles?.message}
        </Typography>
      </div>
      <div className={styles.row}>
        <RcmpSelectUsers
          multiSelect
          defaultValue={bIsEdit && aObserversData}
          label={intl.get("BoardsPage.observers")}
          isFullWidth
          searchable
          onSelect={fnOnSelectObservers}
          aExcludeOptions={aExcludeObservers}
        />
        <Typography color="#FF3541" type="p3">
          {errors.observers?.message}
        </Typography>
      </div>
    </RcmpModalAdd>
  )
}
